var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f3f6fb"}},[_c('navigation'),_c('appMain'),_c('footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }